import { type VariantProps, cva } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '@/lib/utils';
const alertVariants = cva('relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current text-foreground', {
  variants: {
    variant: {
      default: '',
      destructive: 'bg-red-600/10 dark:bg-red-900/20 border-red-600/20 dark:border-red-900/40 [&>svg]:text-red-600',
      success: 'bg-green-600/10 dark:bg-green-900/20 border-green-600/20 dark:border-green-900/40 [&>svg]:text-green-600',
      warning: 'bg-yellow-600/10 dark:bg-yellow-900/20 border-yellow-600/20 dark:border-yellow-900/40 [&>svg]:text-yellow-600',
      info: 'bg-blue-600/10 dark:bg-blue-900/20 border-blue-600/20 dark:border-blue-900/40 [&>svg]:text-blue-600'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({
    variant
  }), className)} {...props} data-sentry-component="Alert" data-sentry-source-file="alert.tsx" />;
}
function AlertTitle({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return <div data-slot="alert-title" className={cn('col-start-2 min-h-4 line-clamp-1 font-medium tracking-tight text-foreground', className)} {...props} data-sentry-component="AlertTitle" data-sentry-source-file="alert.tsx" />;
}
function AlertDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return <div data-slot="alert-description" className={cn('col-start-2 grid justify-items-start gap-1 text-sm text-foreground', className)} {...props} data-sentry-component="AlertDescription" data-sentry-source-file="alert.tsx" />;
}

// Create a compound component with TypeScript support
type AlertCompoundComponent = typeof Alert & {
  Title: typeof AlertTitle;
  Description: typeof AlertDescription;
};
const AlertComponent = Alert as AlertCompoundComponent;
AlertComponent.Title = AlertTitle;
AlertComponent.Description = AlertDescription;
export { AlertComponent as Alert, AlertTitle, AlertDescription };